module.exports = __webpack_public_path__ + "static/media/contest2025_second_place_image.07284865.jpeg";